/**
 * @generated SignedSource<<5e6e51ae2d21ac44e62f0be3393b391c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Currency = "USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useShippingPrice_item$data = {
  readonly relevantShippingInfo?: {
    readonly shipmentQuote: {
      readonly buyerTotalAmount: {
        readonly convertedAmountList: ReadonlyArray<{
          readonly currency: Currency | null;
          readonly amount: number | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"freeShippingHelpers_item">;
  readonly " $fragmentType": "useShippingPrice_item";
};
export type useShippingPrice_item$key = {
  readonly " $data"?: useShippingPrice_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPrice_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "buyerId"
    },
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "fetchLiveShipmentQuote"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchShippingCostInfo"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShippingPrice_item",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "freeShippingHelpers_item",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vertical",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentQuote",
          "kind": "LinkedField",
          "name": "shipmentQuotes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isComplimentary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "totalAmount",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ShipmentServiceMethod",
              "kind": "LinkedField",
              "name": "serviceMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Region",
                  "kind": "LinkedField",
                  "name": "region",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "regionName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "fetchShippingCostInfo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "buyerId"
            },
            {
              "kind": "Variable",
              "name": "useLiveEndpoint",
              "variableName": "fetchLiveShipmentQuote"
            }
          ],
          "concreteType": "RelevantShippingInfo",
          "kind": "LinkedField",
          "name": "relevantShippingInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ShipmentQuote",
              "kind": "LinkedField",
              "name": "shipmentQuote",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "buyerTotalAmount",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ConvertedAmountList",
                      "kind": "LinkedField",
                      "name": "convertedAmountList",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "currency",
                          "storageKey": null
                        },
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "fcf992160cbaa41195142239e2016741";

export default node;
